var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isVisible)?_c('md-button',{class:_vm.buttonClass,on:{"click":_vm.edit}},[_c('md-tooltip',[_vm._v(_vm._s(_vm.tooltip))]),_c('md-icon',[_vm._v("create")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }